module.exports = __webpack_public_path__ + "static/media/blog-46.acb4066d.webp";